export const state = {
    marca: {},
    marcas: [],
    modalCadastroMarca: false,
    modalExcluirMarca:false
}

export default {}